const hotel = {
  availableMealPlans: "Plans de repas disponibles", // translated
  availableRoomsTypes: "Types de chambres disponibles", // translated
  cancellationPolicy: "Politique d'annulation", // translated
  freeCancellationAvailable: "Annulation gratuite disponible", // translated
  nonRefundable: "Non remboursable", // translated
  priceFor: "prix pour", // translated
  nights: "nuits", // translated
  totalPrice: "Prix total", // translated
  seeAvailability: "Voir la disponibilité", // translated
  myProfile: "Mon profil", // translated
  travelTrust: "Fiducie de voyage", // translated
  signIn: "S'identifier", // translated
  searchNow: "Rechercher maintenant", // translated
  policy: "Politique", // translated
  hotelName: "Nom de l'Hotel", // translated
  cxlPolicy: "Politique CXL", // translated
  room: "chambre", // translated
  reservationDate: "Date de réservation", // translated
  maxPax: "Nombre maximum de personnes", // translated
  cxlRules: "Règles CXL", // translated
  cancellationRules: "Règles d'annulation", // translated
  beddingType: "Type de literie", // translated
};

export default hotel;
